import { render, staticRenderFns } from "./MobileVoterReg.vue?vue&type=template&id=c7942390&"
import script from "./MobileVoterReg.vue?vue&type=script&lang=js&"
export * from "./MobileVoterReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports